'use strict';

var angular = require('angular');
var _ = require('lodash');
var ServiceAnalysisModeController = function ServiceAnalysisModeController($scope, $controller, $q, dataRetrieverService, dataRetrieverConstantsService, marketAnalysisPanelService, userPreferencesService) {
  $scope.mode = dataRetrieverConstantsService.SERVICE_MODE;
  $scope.serviceViewReady = $q.defer();
  $scope.markFilterChanged = false;
  $scope.kpiRibbonCollapsed = userPreferencesService.getUserSettingComponent('collapseKpis');
  $scope.showKpiTarget = userPreferencesService.getUserSettingComponent('showKpiTarget');
  angular.extend(this, $controller('AnalysisModeController', {
    $scope: $scope
  }));
  var serviceDataRetriever = dataRetrieverService.getDataRetriever($scope.screen, $scope.mode);
  var bookingMatrixDataRetriever = dataRetrieverService.getDataRetriever($scope.screen, dataRetrieverConstantsService.BOOKING_MATRIX_MODE);
  function isOneDaySelected(brushSelectionFilter) {
    if (!brushSelectionFilter.isEmpty()) {
      var filterArguments = brushSelectionFilter.filterArguments[0];
      return filterArguments[0].from.valueOf() === filterArguments[0].to.valueOf();
    }
  }
  $scope.$on('service-analysis:filterUpdated', function () {
    if (!$scope.markFilterChanged) {
      $scope.markFilterChanged = true;
      $scope.serviceViewReady.reject();
      $scope.serviceViewReady = $q.defer();
      var serviceViewReadyPromise = $scope.serviceViewReady.promise;
      serviceViewReadyPromise.then($scope.setSearchRule);
    }
  });
  function setOneDaySelected(isOneDaySelected) {
    $scope.$broadcast('service-analysis:oneDaySelected', isOneDaySelected);
  }
  $scope.onBrushChange = function (event, brushSelectionFilter) {
    if (brushSelectionFilter.filterType === 'dateRange') {
      var isBrushFilterSelected = brushSelectionFilter.filterArguments[0].length !== 0;
      if (!isBrushFilterSelected) {
        setOneDaySelected(false);
      } else {
        var oneDaySelected = isOneDaySelected(brushSelectionFilter);
        if (oneDaySelected) {
          var searchRules = marketAnalysisPanelService.buildServiceSearchRule($scope.filterData);
          var selectedDay = brushSelectionFilter.filterArguments[0][0].from;
          var departureDateRule = _.find(searchRules, {
            field: 'departureDate'
          });
          departureDateRule.leftOperand = selectedDay.startOf('day');
          departureDateRule.rightOperand = selectedDay.endOf('day');
          bookingMatrixDataRetriever.setCustomSearchCriteriaRules(searchRules);
          $scope.$broadcast('grid:loadData:service-demand-analysis-booking-matrix');
        } else {
          $scope.$broadcast('service-analysis:switch-view:service-demand-analysis-booking-matrix', 'default-view');
        }
        setOneDaySelected(oneDaySelected);
      }
    }
  };
  $scope.$on('brush-filter:defaultBrush', $scope.onBrushChange);
  $scope.$on('brush-filter:filterApplied', $scope.onBrushChange);
  $scope.setSearchRule = function () {
    $scope.markFilterChanged = false;
    var searchRule = marketAnalysisPanelService.buildServiceSearchRule($scope.filterData);
    if (!_.isEqual(searchRule, serviceDataRetriever.getSearchCriteriaRules())) {
      //overwrite the stored dataRetriever and clear the previous state
      serviceDataRetriever.setCustomSearchCriteriaRules(searchRule);
      serviceDataRetriever.selectedDimension($scope.screenState.dimension);
    }
    $scope.dataReady = true;
    $scope.$broadcast('search-criteria:searchChangeEvent');
  };
  $scope.setServiceViewReady = function (ready) {
    if (ready) {
      $scope.serviceViewReady.resolve();
    }
  };
  $scope.screenState.isServiceGridExpanded = undefined === $scope.screenState.isServiceGridExpanded ? userPreferencesService.getUserSettingComponent('isServiceGridExpanded') : false;
  $scope.$on('gridExpand:service-demand-analysis', function () {
    $scope.screenState.isServiceGridExpanded = !$scope.screenState.isServiceGridExpanded;
  });
};
ServiceAnalysisModeController.$inject = ['$scope', '$controller', '$q', 'DataRetrieverService', 'DataRetrieverConstantsService', 'MarketAnalysisPanelService', 'UserPreferencesService'];
module.exports = ServiceAnalysisModeController;